import React from 'react'
import BaseComponent from './BaseContainer'
import { graphql, compose, withApollo } from 'react-apollo'
import BlogForm from '../components/form/Blog'
import getBlog from '../apollo/graphql/blog/get'
import createBlog from '../apollo/graphql/blog/create'
import updateBlog from '../apollo/graphql/blog/update'
import getLanguages from '../apollo/graphql/getLanguages'
import { convertGraphQlToObject, convertObjetToGraphQlVariables } from '../helpers/contentWithI18n'
import { languages } from '../constants'
import { createTranslationsObject } from '../helpers/translation'

class BlogContainer extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: false
      },
      redirect: false,
      obj: {
        translations: createTranslationsObject({
          title: ''
        })
      },
      languages: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.props.client.query({
      query: getBlog
    }).then(({ data }) => {
      let newState

      if (data.getBlog === null) {
        newState = {
          status: {
            ...this.state.status,
            isNew: true
          }
        }
      } else {
        const newObject = {...this.state.obj, ...convertGraphQlToObject(data.getBlog)}
        newState = {
          ...this.state,
          status: {
            ...this.state.status,
            loading: false
          },
          obj: {
            ...this.state.obj,
            ...newObject,
            translations: {
              ...this.state.obj.translations,
              ...newObject.translations
            }
          }
        }
      }

      newState.status.loading = false

      this.setState(newState)
    }).catch((error) => {
      this.setState({
        status: {
          ...this.state.status,
          loading: false,
          message: error.message,
          error: true,
          isNew: true
        }
      })
    })
  }

  handleChange (event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj
      }
    }

    let dataIsLanguage = false

    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true
      }
    }

    if (dataIsLanguage) {
      // translations data
      newState.obj.translations[data][event.target.id] = event.target.value
    } else if (event.target.files && event.target.files.length > 0) {
      // files
      newState.obj[event.target.id] = event.target.files[0]
    }

    this.setState(newState)
  }

  handleSubmit (event) {
    event.preventDefault()

    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })

    let obj = convertObjetToGraphQlVariables(this.state.obj)

    if (this.state.status.isNew) {
      this.props.createBlog({
        variables: {
          ...obj
        }
      }).then((data) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: `Création effectuée le ${new Date(Date.now()).toLocaleString()}`,
            isNew: false
          },
          obj: convertGraphQlToObject(data.data.createBlog)
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      })
    } else {
      this.props.updateBlog({
        variables: {
          id: this.state.obj.id,
          ...obj
        }
      }).then((data) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: `Mise à jour effectuée le ${new Date(Date.now()).toLocaleString()}`,
            isNew: false
          },
          obj: convertGraphQlToObject(data.data.updateBlog)
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: false
          }
        })
      })
    }
  }

  render () {
    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return <BlogForm
      obj={this.state.obj}
      status={this.state.status}
      languages={this.props.languages}
      onChange={this.handleChange}
      onSubmit={this.handleSubmit}
      onDelete={this.handleDelete}/>
  }
}

const BlogContainerEnhanced = compose(
  graphql(getLanguages, { name: 'languages' }),
  graphql(updateBlog, { name: 'updateBlog' }),
  graphql(createBlog, { name: 'createBlog' })
)(BlogContainer)

export default withApollo(BlogContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/BlogContainer.js